import React from 'react';
import PropTypes from 'prop-types';

import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import SrButton, {
  SR_BUTTON_THEME_ADOBE_YELLOW,
  SR_BUTTON_THEME_ADOBE_GREY,
} from 'client/components/SrButton/SrButton';
import SrModalV2, { MODAL_THEME_STACK } from 'client/components/SrModalV2/SrModalV2';

const SrPartnerListingWithdrawModal = ({ children, disabled, confirmText, onClose, onConfirm }) => {
  return (
    <SrModalV2
      closeOnBackgroundClick
      onClose={onClose}
      showCloseButton={false}
      contentMaxWidth="375px"
      padding="0"
      margin="1vh auto 0 auto"
      contentPadding="40px 34px"
      contentOverflow="unset"
      theme={MODAL_THEME_STACK}
    >
      <SrBox>
        {children}
        <SrFlex marginTop="20px">
          <SrButton
            theme={SR_BUTTON_THEME_ADOBE_YELLOW}
            type="submit"
            hasBoxShadow
            disabled={disabled}
            onClick={onConfirm}
          >
            {confirmText}
          </SrButton>
        </SrFlex>
        <SrFlex marginTop="20px">
          <SrButton theme={SR_BUTTON_THEME_ADOBE_GREY} onClick={onClose} hasBoxShadow>
            Cancel
          </SrButton>
        </SrFlex>
      </SrBox>
    </SrModalV2>
  );
};

SrPartnerListingWithdrawModal.defaultProps = {
  confirmText: 'Continue',
};

SrPartnerListingWithdrawModal.propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  confirmText: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

SrPartnerListingWithdrawModal.displayName = 'SrPartnerListingWithdrawModal';

export default SrPartnerListingWithdrawModal;
